export const selfHostedComputersPath = (tenantId: string) =>
  `o/${tenantId}/integrations/self-hosted/computers`;

export const SELF_HOSTED_LABEL_DELIMITER = "=";
